import { IProperty } from './AndromeTV.types';

export class Translation {
  private map: Map<string, string>;

  /**
   * Creates a translation object
   */
  constructor(translations: IProperty[]) {
    this.map = new Map();
    translations.forEach(trn => {
      this.map.set(trn.name, trn.value);
    });
  }

  /**
   * Returns the translation for a specific key.
   * If no value exists for the key, the key surrounded with asterisks is returned
   */
  forKey(key: string): string {
    if (this.map.has(key)) {
      return this.map.get(key) as string;
    }
    return `*${key}*`;
  }

  forGenres(keys: string[]) {
    const result: string[] = [];
    keys.forEach(key => {
      if (this.map.has(key)) {
        result.push(this.map.get(key) as string);
      }
    });
    return result;
  }
}
